<template>

    <div id="login-window">

        <h1 class="text-center">Logg inn</h1>

        <b-form @submit="onSubmit" class="mb-3">
            <b-form-group >
                <b-form-input type="text" name="cardId" v-model="form.cardId" placeholder="Kort ID" trim/>
            </b-form-group>
            <b-form-group   >
                <b-form-input type="password" name="pin" v-model="form.pin" placeholder="PIN" trim/>
            </b-form-group>

            <b-alert show variant="danger" v-if="errors.length" class="errors">

                <ul>
                    <li  v-for="error in errors" :key="error">
                        {{ error }}
                    </li>
                </ul>


            </b-alert>

            <b-button type="submit" variant="primary">Kjør på!</b-button>
        </b-form>


    </div>

</template>

<script>

export default {
    name: 'LoginWindow',
    data() {
        return {
            form: {
                cardId: process.env.VUE_APP_TEST_CARD_ID ? process.env.VUE_APP_TEST_CARD_ID : '',
                pin: process.env.VUE_APP_TEST_CARD_PIN ? process.env.VUE_APP_TEST_CARD_PIN : '',
            },
            errors: [],
            messages: {
                register: false,
            }
        }

    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault()

            // Validation
            this.errors = []
            this.messages.register = false;

            if (!this.form.cardId) this.errors.push('Kornummer mangler.')
            if (!this.form.pin) this.errors.push('PIN mangler.')


            if (this.errors.length == 0) {

                this.loginUser();

            }
        },
        loginUser() {
            this.$api.post('/login/', {}, {
                auth: {
                    username: this.form.cardId,
                    password: this.form.pin
                }
            })
            .then((response) => {
                this.$store.setToken(response.data.token);
                this.$store.setUser(response.data.user)

                this.$api.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token;


                this.$router.replace('/').catch((e) => {console.log(e)});;
            })
            .catch((error) => {

                if (error.response) {
                    let code = error.response.status;
                    let data = error.response.data;

                    if (code == 401) {
                        this.errors.push('Du har tastet inn feil kortnummer eller PIN.')
                    }
                    else if (code == 404) {
                        this.$emit("register",this.form)
                    }
                    else if (code == 403) {
                        this.errors.push(data.error.description);
                    }
                    else {
                        this.errors.push('En ukjent feil har oppstått. Kontakt support.')
                    }
                }
                else {
                    this.errors.push('En ukjent feil har oppstått. Kontakt support.')
                }
            });

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

h1 {
    margin-bottom: 1em;
}

.login .errors ul {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
}

.login .logo {
    max-width: 100px;
    margin-bottom: 2em;
}

</style>
